<template>
    <section class="gz-auth-view-template">
        <section v-if="bc" class="gz-auth-view-template__breadcrumbs">
            <GZ-Breadcrumbs />
        </section>
        
        <section class="gz-auth-view-template__content" :class="contentClass">
            <section v-if="hasAboveTitleSlot">
                <slot name="above-title"></slot>
            </section>

            <section v-if="hasTitleSlot" class="gz-auth-view-template__content__section">
                <slot name="title"></slot>
            </section>
            
            <section v-if="hasUnderTitleSlot" class="gz-auth-view-template__content__section">
                <slot name="under-title"></slot>
            </section>

            <section v-if="hasNotificationSlot" class="gz-auth-view-template__content__section">
                <slot name="notification"></slot>
            </section>

            <section v-if="hasUnderNotificationSlot" class="gz-auth-view-template__content__section">
                <slot name="under-notification"></slot>
            </section>
            
            <section v-if="hasActionsSlot" class="gz-auth-view-template__content__section">
                <slot name="actions"></slot>
            </section>

            <section v-if="hasAboveContentSlot" class="gz-auth-view-template__content__section">
                <slot name="above-content"></slot>
            </section>
           
            <section v-if="hasFiltersSlot">
                <slot name="filters"></slot>
            </section>
            
            <section v-if="hasContentSlot" class="gz-auth-view-template__content__section">
                <slot name="content"></slot>
            </section>

            <section v-if="hasUnderContentSlot" class="gz-auth-view-template__content__section">
                <slot name="under-content"></slot>
            </section>

            <section v-if="hasPaginationSlot" class="gz-auth-view-template__content__section">
                <slot name="pagination"></slot>
            </section>
            
            <section v-if="hasUnderPaginationSlot" class="gz-auth-view-template__content__section">
                <slot name="under-pagination"></slot>
            </section>
        </section>
    </section>
</template>

<script>
export default {
    name: 'BaseAuthViewTemplate',

    props: {
        bc: {
        //BreadCrumbs
            type: Boolean,
            default: true
        },
        contentClass: String
    },
    computed: {
        hasTitleSlot() {
            return this.$slots.title
        },
        hasUnderTitleSlot() {
            return this.$slots['under-title']
        },
        hasAboveTitleSlot() {
            return this.$slots['above-title']
        },
        hasNotificationSlot() {
            return this.$slots.notification
        },
        hasUnderNotificationSlot() {
            return this.$slots['under-notification']
        },
        hasActionsSlot() {
            return this.$slots['actions']
        },
        hasAboveContentSlot() {
            return this.$slots['above-content']
        },
        hasFiltersSlot() {
            return this.$slots.filters
        },
        hasContentSlot() {
            return this.$slots.content
        },
        hasUnderContentSlot() {
            return this.$slots['under-content']
        },
        hasPaginationSlot() {
            return this.$slots.pagination
        },
        hasUnderPaginationSlot() {
            return this.$slots['under-pagination']
        }
    }
}
</script>